import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes, { shape } from 'prop-types';
import I10n from '../features/i10n';
import MsxIcons from '../features/msx-icons';
import Device from '../models/Device';
import RangeInfo from '../models/RangeInfo';
import ConnectionTypeSettings from './connection_type_settings';
import ProductInformationCache from '../persistence/description-cache';
import SlottedAdditionalDevicesSettings from './slotted_additionnal_devices_settings';
import FuseSettings from './fuse_settings';
import DynamicLabel from '../atoms/dynamic-label';
import { SeList, SeListItem } from '@se/web-ui-react';
import LoadingSpinner from '../atoms/loading';
import { formatLengthUnit } from '../utils/data-formatter';
import { configurationModuleType, edgeClusterHead, preferredProductReference } from '../constants';
import DropdownMenu from './dropdown_menu';
import Scrollbars from 'react-custom-scrollbars';
import Button from '../atoms/button';
import ProductLink from './product_link';
import { PRIMARY_COLOR } from '../color-constants';

const Container = styled.div`
  border: 1px solid #e7e6e6;
  margin-top: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  @media (max-width: 800px) {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: white;
    margin-top: 0px;
    z-index: 350;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  width: 100%;
`;

const ModuleIDAndTitleWrapper = styled.h2`
  margin: 0;
  margin-right: 10px;
  padding: 0;
  font-size: 16px !important;
  line-height: 18px !important;
  color: #333333;
  font-weight: bold;
  display: flex;
`;

const ModuleTitle = styled.span`
`;

const ModuleIDWrapper = styled.div`
  margin-left: 5px;
`;

const Action = styled.span`
  display: inline-block;
  margin-left: 15px;
  font-size: 12px;
  line-height: 14px;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  font-weight: bold;
  cursor: pointer;
`;

const Icon = styled.span`
  display: inline-block;
  height: 20px;
  width: 20px;
  cursor: pointer;
`;
const CloseIcon = styled(Icon)`
  color: black;
`;
const RemoveIcon = styled(Icon)`
  height: 16px;
  width: 16px;
`;
const ActionIcon = styled(Icon)`
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileContent = styled.div`
  display: none;
  flex-direction: column;
  flex: 1 1 0px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const Body = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 5px;
`;

const InformationWrapper = styled.div`
  flex: 1 1 0px;
  display: block;
`;

const ModuleDescription = styled.p`
  margin: 0;
  color: #333333;
  font-size: 14px !important;
  line-height: 17px !important;
`;

const InformationRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  flex-wrap: wrap;
`;

const InformationRowTitle = styled.h3`
  margin: 0;
  margin-bottom: 4px;
  padding: 0;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #333333;
  font-weight: bold;
`;

const ModuleInfo = styled.div`
  margin-top: 10px;
  margin-right: 16px;
`;

const ModuleDimension = styled(ModuleInfo)`
`;

const ModuleDimensionTitle = styled(InformationRowTitle)`
`;

const ModuleConsumption = styled(ModuleInfo)`
`;

const ModuleConsumptionTitle = styled(InformationRowTitle)`
`;

const ModuleCartridge = styled(ModuleInfo)`
`;

const ModuleCartridgeTitle = styled(InformationRowTitle)`
`;

const ModuleCartridgeList = styled.ol`
  margin: 0;
  padding: 0;
  padding-left: 15px;
`;
const ModuleCartridgeListItem = styled.li`
  font-size: 12px;
  line-height: 24px;
`;
const CartridgeWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`;
const CartridgeAction = styled(Action)`
  margin-left: 0;
`;
const CartridgeId = styled.a`
  display: inline-block;
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  text-decoration: none !important;
`;

const TableValue = styled.table`
  border-collapse: collapse;
  color: #333333;
  --dynamic-label-color: #333333;
`;

const TableValueBody = styled.tbody`
`;

const TableValueRow = styled.tr`
`;

const TableValueCell = styled.td`
  padding: 5px 8px;
  border: 1px solid #E7E6E6;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
`;

const RangeImage = styled.img`
  display: block;
  height : 100px;
  width: auto;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileRangeImage = styled.img`
  display: none;
  height : 100px;
  width: auto;
  @media (max-width: 800px) {
    display: block;
  }
`;

const MobileImageAndDescriptionWrapper = styled.div`
  display: flex;
`;

const LoadingSpinnerWrapper = styled.div`
  height: 10px;
  width: 10px;
  padding: 10px;
`;

const PreferedProductReference = styled.span`
  color: rgb(160, 164, 168);
  font-weight: bold;
  font-size: 10px;
`;

const ModuleActionsWrapper = styled.div`
  display: flex;
`;

const ModuleAction = styled.div`
  display: flex;
  margin-right: 10px;
  cursor: pointer;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
`;

const DesktopModuleAction = styled(ModuleAction)`
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileModuleAction = styled(ModuleAction)`
  display: none;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const ActionMenuWrapper = styled.div`
  display: flex;
  width: 150px;
`;

const DesktopActionMenuWrapper = styled(ActionMenuWrapper)`
  display: flex;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileActionMenuWrapper = styled(ActionMenuWrapper)`
  display: none;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobileCloseButtonSection = styled.div`
  display: none;
  @media (max-width: 800px) {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
`;

class ModuleSettings extends React.Component {

  static propTypes = {
    module: shape(Device),
    rangeInfo: shape(RangeInfo),
    cartridges: PropTypes.array,
    cartridgeMaxQuantity: PropTypes.number,
    hasCartridges: PropTypes.func,
    hasConnectionType: PropTypes.func,
    hasFuse: PropTypes.func,
    hasSlottedAdditionalDevices: PropTypes.func,
    canHandleCartridgeActions: PropTypes.func,
    canShowScreenAccessories: PropTypes.func,
    canShowSparePartAccessories: PropTypes.func,
    onAddCartridgeRequested: PropTypes.func,
    onRemoveCartridgeRequested: PropTypes.func,
    onReplaceModuleRequested: PropTypes.func,
    onAdjustRequested: PropTypes.func,
    onInsertModuleLeftRequested: PropTypes.func,
    onInsertModuleRightRequested: PropTypes.func,
    canDuplicate: PropTypes.func,
    canRemove: PropTypes.func,
    canInsertLeft: PropTypes.func,
    canInsertRight: PropTypes.func,
    canReplace: PropTypes.func,
    canAdjust: PropTypes.func,
    onDuplicate: PropTypes.func,
    onReplace: PropTypes.func,
    onUpdate: PropTypes.func,
    onSlottedAdditionalDeviceChange: PropTypes.func,
    onInsertBefore: PropTypes.func,
    onSoftwareVersionChange: PropTypes.func,
    onRemove: PropTypes.func,
    onClose: PropTypes.func,
    isLoading: PropTypes.bool,
    moduleActionsLoading: PropTypes.bool,
    showSoftwareVersion: PropTypes.func,
    softwareVersion: PropTypes.string,
    preferredProductReference: PropTypes.string,
    starterType: PropTypes.string
  }

  shouldRenderModuleActions = () => {
    return (this.props.canInsertLeft(this.props.module) || this.props.canInsertRight(this.props.module) || this.props.canRemove(this.props.module));
  }

  renderModuleActions = (closeModuleSttings = false) => {
    return (
      <SeList option="dropdown" role="list">
        {this.props.canInsertLeft(this.props.module) &&
          <SeListItem data-close item={I10n.get('module_setting.action.insert_left')} onClick={() => { this.props.onInsertModuleLeftRequested(closeModuleSttings) }}>
          </SeListItem>
        }
        {this.props.canInsertRight(this.props.module) &&
          <SeListItem data-close item={I10n.get('module_setting.action.insert_right')} onClick={() => { this.props.onInsertModuleRightRequested(closeModuleSttings) }}>
          </SeListItem>
        }
        {this.props.canRemove(this.props.module) &&
          <SeListItem data-close item={I10n.get('module_setting.action.remove')} onClick={() => { this.props.onRemove() }}>
          </SeListItem>
        }
      </SeList>
    );
  }

  renderContent = (device, ioModuleRangeName) => {

    const description = I10n.getOrDefault(`modules.${device.id}.description`, ProductInformationCache.getDescription(device.id), 'data') || device.description;

    return <>
      <Body>
        <InformationWrapper>
          <MobileImageAndDescriptionWrapper>
            {device.sidePicture &&
              <MobileRangeImage src={device.sidePicture}></MobileRangeImage>
            }
            <ModuleDescription>{description}</ModuleDescription>
          </MobileImageAndDescriptionWrapper>
          <InformationRow>
            <ModuleDimension>
              <ModuleDimensionTitle>{I10n.get('module_setting.information.dimension')}</ModuleDimensionTitle>
              <TableValue>
                <TableValueBody>
                  <TableValueRow>
                    <TableValueCell>
                      {I10n.get('module_setting.information.dimension.height')}
                    </TableValueCell>
                    <TableValueCell>
                      {formatLengthUnit(device.height)}
                    </TableValueCell>
                  </TableValueRow>
                  <TableValueRow>
                    <TableValueCell>
                      {I10n.get('module_setting.information.dimension.width')}
                    </TableValueCell>
                    <TableValueCell>
                      {formatLengthUnit(device.width)}
                    </TableValueCell>
                  </TableValueRow>
                </TableValueBody>
              </TableValue>
            </ModuleDimension>
            {device.hasConsumption() &&
              <ModuleConsumption>
                <ModuleConsumptionTitle>{I10n.get('module_setting.information.consumption')}</ModuleConsumptionTitle>
                <TableValue>
                  <TableValueBody>
                    {device.consumption3Dot3V > 0 && <TableValueRow>
                      <TableValueCell>
                        {I10n.getAndReplace(`configuration.general.consumption.${ioModuleRangeName}.3_3v`, '')}
                      </TableValueCell>
                      <TableValueCell>
                        {device.consumption3Dot3V} {I10n.get('unit.mA', 'data')}
                      </TableValueCell>
                    </TableValueRow>}
                    {device.consumption5V > 0 && <TableValueRow>
                      <TableValueCell>
                        {I10n.getAndReplace(`configuration.general.consumption.${ioModuleRangeName}.5V`, '')}
                      </TableValueCell>
                      <TableValueCell>
                        {device.consumption5V} {I10n.get('unit.mA', 'data')}
                      </TableValueCell>
                    </TableValueRow>}
                    {device.consumption24V > 0 && <TableValueRow>
                      <TableValueCell>
                        {I10n.getAndReplace(`configuration.general.consumption.${ioModuleRangeName}.24V`, '')}
                      </TableValueCell>
                      <TableValueCell>
                        {device.consumption24V} {I10n.get('unit.mA', 'data')}
                      </TableValueCell>
                    </TableValueRow>}
                    {device.consumption24VSensors > 0 && <TableValueRow>
                      <TableValueCell>
                        {I10n.getAndReplace(`configuration.general.consumption.${ioModuleRangeName}.24V_sensors`, '')}
                      </TableValueCell>
                      <TableValueCell>
                        {device.consumption24VSensors} {I10n.get('unit.mA', 'data')}
                      </TableValueCell>
                    </TableValueRow>}
                  </TableValueBody>
                </TableValue>
              </ModuleConsumption>
            }
            {device.isPowerSupplier() &&
              <ModuleConsumption>
                <ModuleConsumptionTitle>{I10n.get('module_setting.information.block_consumption')}</ModuleConsumptionTitle>
                <TableValue>
                  <TableValueBody>
                    {device.maxConsumption3Dot3V > 0 && <TableValueRow>
                      <TableValueCell>
                        {I10n.getAndReplace(`configuration.general.consumption.${ioModuleRangeName}.3_3v`, '')}
                      </TableValueCell>
                      <TableValueCell>
                        {device.maxConsumption3Dot3V} {I10n.get('unit.mA', 'data')}
                      </TableValueCell>
                    </TableValueRow>}

                    {device.maxConsumption5V > 0 && <TableValueRow>
                      <TableValueCell>
                        {I10n.getAndReplace(`configuration.general.consumption.${ioModuleRangeName}.5V`, '')}
                      </TableValueCell>
                      <TableValueCell>
                        {device.maxConsumption5V} {I10n.get('unit.mA', 'data')}
                      </TableValueCell>
                    </TableValueRow>}

                    {device.maxConsumption24V > 0 && <TableValueRow>
                      <TableValueCell>
                        {I10n.getAndReplace(`configuration.general.consumption.${ioModuleRangeName}.24V`, '')}
                      </TableValueCell>
                      <TableValueCell>
                        {device.maxConsumption24V} {I10n.get('unit.mA', 'data')}
                      </TableValueCell>
                    </TableValueRow>}
                    {device.maxConsumption24VSensors > 0 && <TableValueRow>
                      <TableValueCell>
                        {I10n.getAndReplace(`configuration.general.consumption.${ioModuleRangeName}.24V_sensors`, '')}
                      </TableValueCell>
                      <TableValueCell>
                        {device.maxConsumption24VSensors} {I10n.get('unit.mA', 'data')}
                      </TableValueCell>
                    </TableValueRow>}



                  </TableValueBody>
                </TableValue>
              </ModuleConsumption>
            }
            {device.hasSpecialConsumptions() &&
              <ModuleConsumption>
                <ModuleConsumptionTitle>{I10n.get('module_setting.information.special_consumption')}</ModuleConsumptionTitle>
                <TableValue>
                  <TableValueBody>
                    {device.maxConsumptionLoads > 0 &&
                      <TableValueRow>
                        <TableValueCell>
                          {I10n.getOrDefault(`configuration.general.consumption.loads.${ioModuleRangeName}`, I10n.get(`configuration.general.consumption.loads`))}
                        </TableValueCell>
                        <TableValueCell>
                          <DynamicLabel
                            value={'' + device.consumptionLoads}
                            renderValue={v => `${v} ${I10n.get('unit.mA', 'data')}`}
                            setValue={v => {
                              let value = parseFloat(v, 10);
                              if (isNaN(value) || value > device.maxConsumptionLoads) {
                                value = device.maxConsumptionLoads;
                              } else if (value < 0) {
                                value = 0;
                              }
                              this.props.onUpdate({ consumptionLoads: value })
                            }}
                            enableEdit={!this.props.isLoading && device.hasCustomConsumptionLoads}
                            withCancel={true}
                            customInputProps={{
                              type: "number", name: "consumptionLoads",
                              min: "0", max: device.maxConsumptionLoads, step: "10",
                            }}
                          ></DynamicLabel>
                        </TableValueCell>
                      </TableValueRow>
                    }
                    {device.maxConsumptionDevices > 0 &&
                      <TableValueRow>
                        <TableValueCell>
                          {I10n.get(`configuration.general.consumption.devices`)}
                        </TableValueCell>
                        <TableValueCell>
                          <DynamicLabel
                            value={'' + device.consumptionDevices}
                            renderValue={v => `${v} ${I10n.get('unit.mA', 'data')}`}
                            setValue={v => {
                              let value = parseInt(v, 10);
                              if (isNaN(value) || value > device.maxConsumptionDevices) {
                                value = device.maxConsumptionDevices;
                              } else if (value < 0) {
                                value = 0;
                              }
                              this.props.onUpdate({ consumptionDevices: value })
                            }}
                            enableEdit={!this.props.isLoading && device.hasCustomConsumptionDevices}
                            withCancel={true}
                            customInputProps={{
                              type: "number", name: "consumptionDevices",
                              min: "0", max: device.maxConsumptionDevices, step: "10",
                            }}
                          ></DynamicLabel>
                        </TableValueCell>
                      </TableValueRow>
                    }
                  </TableValueBody>
                </TableValue>
              </ModuleConsumption>
            }
            {this.props.hasConnectionType() &&
              <ModuleInfo>
                <ConnectionTypeSettings
                  module={device}
                  isLoading={this.props.isLoading}
                  onConnectionTypeClick={this.props.onReplace}>
                </ConnectionTypeSettings>
              </ModuleInfo>
            }
            {this.props.hasFuse() &&
              <ModuleInfo>
                <FuseSettings
                  module={device}
                  isLoading={this.props.isLoading}
                  onFuseClick={this.props.onReplace}>
                </FuseSettings>
              </ModuleInfo>
            }
            {this.props.hasSlottedAdditionalDevices() &&
              <ModuleInfo>
                <SlottedAdditionalDevicesSettings
                  module={device}
                  isLoading={this.props.isLoading}
                  onSelectedSlottedDeviceChange={this.props.onSlottedAdditionalDeviceChange}
                  starterType={this.props.starterType}
                >
                </SlottedAdditionalDevicesSettings>
              </ModuleInfo>
            }
            {this.getCartridgeSlots().length > 0 &&
              <ModuleCartridge>
                <ModuleCartridgeTitle>{I10n.get('module_setting.information.manage_cartridge')}</ModuleCartridgeTitle>
                <ModuleCartridgeList>
                  {this.getCartridgeSlots().map(slot => {
                    const cartridge = this.props.cartridges.find(c => c.slot === slot);
                    return (
                      <ModuleCartridgeListItem key={slot}>
                        <CartridgeWrapper>
                          {!cartridge && (
                            <Fragment>
                              {this.props.canHandleCartridgeActions(device) && (
                                <CartridgeAction
                                  title={I10n.get('module_setting.action.add_cartridge')}
                                  onClick={() => this.props.onAddCartridgeRequested(slot)}>
                                  {I10n.get('module_setting.action.add_cartridge')}
                                </CartridgeAction>
                              )}
                              {!this.props.canHandleCartridgeActions(device) && (
                                <span>...</span>
                              )}
                            </Fragment>
                          )}
                          {cartridge && (
                            <Fragment>
                              <CartridgeId
                                href={'https://www.schneider-electric.com/en/product/' + cartridge.id} target="_blank"
                                title={ProductInformationCache.getDescription(cartridge.id)}
                              >
                                {cartridge.id}
                              </CartridgeId>
                              {this.props.canHandleCartridgeActions(device) && (
                                <CartridgeAction>
                                  <RemoveIcon
                                    title={I10n.get('module_setting.action.remove_cartridge')}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.props.onRemoveCartridgeRequested(slot, cartridge);
                                    }}>
                                    <MsxIcons name="remove" size="custom" color="error"></MsxIcons>
                                  </RemoveIcon>
                                </CartridgeAction>
                              )}
                            </Fragment>
                          )}
                        </CartridgeWrapper>
                      </ModuleCartridgeListItem>
                    )
                  })}
                </ModuleCartridgeList>
              </ModuleCartridge>
            }
          </InformationRow>
        </InformationWrapper>
        <RangeImage src={device.sidePicture}></RangeImage>
      </Body>
    </>;

  }

  render = () => {
    const device = this.props.module;
    const ioModuleRangeName = this.props.rangeInfo.rangeIOModule;

    return (
      <Container>
        <HeaderWrapper>
          <ModuleIDAndTitleWrapper>
            <ModuleTitle>
              {I10n.get('module_setting.title')}
            </ModuleTitle>
            <ModuleIDWrapper>
              <ProductLink reference={device.id}></ProductLink>
            </ModuleIDWrapper>
          </ModuleIDAndTitleWrapper>
          <CloseIcon onClick={(e) => {
            e.preventDefault();
            this.props.onClose();
          }}>
            <MsxIcons name="close" size="custom"></MsxIcons>
          </CloseIcon>
        </HeaderWrapper>
        {this.props.preferredProductReference && this.props.preferredProductReference !== preferredProductReference.none &&
          <PreferedProductReference>
            {this.props.preferredProductReference === preferredProductReference.ean
              && I10n.getAndReplace('preferences.ean', ProductInformationCache.getEAN(device.id) || I10n.get('preferences.reference.not_found'))
            }
            {this.props.preferredProductReference === preferredProductReference.enum
              && I10n.getAndReplace('preferences.enumber', ProductInformationCache.getENumber(device.id) || I10n.get('preferences.reference.not_found'))
            }
          </PreferedProductReference>}

        <>
          {(this.props.moduleActionsLoading || this.props.isLoading) ?
            <LoadingSpinnerWrapper>
              <LoadingSpinner width="10px" height="10px"></LoadingSpinner>
            </LoadingSpinnerWrapper>
            :
            <ModuleActionsWrapper>
              {this.props.canDuplicate(this.props.module) &&
                <>
                  <DesktopModuleAction onClick={() => { this.props.onDuplicate(false) }}>
                    <ActionIcon><MsxIcons name="copy" size="nano"></MsxIcons></ActionIcon>
                    {(edgeClusterHead === this.props.module?.productType) ? I10n.get('module_setting.action.duplicate_cluster') : I10n.get('module_setting.action.duplicate')}
                  </DesktopModuleAction>
                  <MobileModuleAction onClick={() => { this.props.onDuplicate(true) }}>
                    <ActionIcon><MsxIcons name="copy" size="nano"></MsxIcons></ActionIcon>
                    {(edgeClusterHead === this.props.module?.productType) ? I10n.get('module_setting.action.duplicate_cluster') : I10n.get('module_setting.action.duplicate')}
                  </MobileModuleAction>
                </>
              }
              {this.props.canReplace(this.props.module) &&
                <>
                  <DesktopModuleAction onClick={() => { this.props.onReplaceModuleRequested(false) }}>
                    <ActionIcon><MsxIcons name="replace" size="nano"></MsxIcons></ActionIcon>
                    {I10n.get('module_setting.action.replace')}
                  </DesktopModuleAction>
                  <MobileModuleAction onClick={() => { this.props.onReplaceModuleRequested(true) }}>
                    <ActionIcon><MsxIcons name="replace" size="nano"></MsxIcons></ActionIcon>
                    {I10n.get('module_setting.action.replace')}
                  </MobileModuleAction>
                </>
              }
              {this.props.canAdjust(this.props.module) &&
                <>
                  <DesktopModuleAction onClick={() => { this.props.onAdjustRequested(this.props.module) }}>
                    <ActionIcon><MsxIcons name="pacdrive-adjust" size="nano"></MsxIcons></ActionIcon>
                    {I10n.get('module_setting.action.adjust')}
                  </DesktopModuleAction>
                  <MobileModuleAction onClick={() => { this.props.onAdjustRequested(this.props.module) }}>
                    <ActionIcon><MsxIcons name="pacdrive-adjust" size="nano"></MsxIcons></ActionIcon>
                    {I10n.get('module_setting.action.adjust')}
                  </MobileModuleAction>
                </>
              }
              {!(configurationModuleType.head_module === device.moduleType) && this.shouldRenderModuleActions() &&
                <DropdownMenu
                  data-clickable
                  toggleElement={<Icon><MsxIcons name="menu-dots" slot="trigger" color="secondary"></MsxIcons></Icon>}
                  containerElement=
                  {
                    <>
                      <DesktopActionMenuWrapper>
                        {this.renderModuleActions(false)}
                      </DesktopActionMenuWrapper>
                      <MobileActionMenuWrapper>
                        {this.renderModuleActions(true)}
                      </MobileActionMenuWrapper>
                    </>
                  }
                  correctionWidthOffset={15}
                >
                </DropdownMenu>
              }
            </ModuleActionsWrapper>}
        </>
        <Content>
          {this.renderContent(device, ioModuleRangeName)}
        </Content>
        <MobileContent>
          <Scrollbars>
            {this.renderContent(device, ioModuleRangeName)}
          </Scrollbars>
        </MobileContent>
        <MobileCloseButtonSection>
          <Button onClick={(e) => {
            e.preventDefault();
            this.props.onClose();
          }}>{I10n.get('app.action.close')}</Button>
        </MobileCloseButtonSection>
      </Container >
    );
  }

  getCartridgeSlots = () => {
    if (!this.props.hasCartridges() || this.props.cartridgeMaxQuantity <= 0) {
      return [];
    }
    // Return for 2 cartridge slots the array [1, 2]
    return Array.from(Array(this.props.cartridgeMaxQuantity), (x, i) => i + 1);
  }
}

export default ModuleSettings;
